"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountryTable = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CountryPicker = require("../CountryPicker.model");
var _Flags = require("../../Flags/Flags");
// Interfaces:

var CountryTable = exports.CountryTable = function CountryTable(props) {
  var allCountries = props.allCountries,
    onChoose = props.onChoose,
    availableCountries = props.availableCountries,
    priorityCountries = props.priorityCountries;
  var drawColumn = function drawColumn(country) {
    var name_ru = country.name_ru,
      country_code = country.country_code,
      visaAvailability = country.visaAvailability,
      _country$closed = country.closed,
      closed = _country$closed === void 0 ? false : _country$closed;
    var disabled = availableCountries.findIndex(function (c) {
      return c.country_code === country_code;
    }) === -1;
    var noVisa = visaAvailability === _CountryPicker.NO_VISA;
    return /*#__PURE__*/_react["default"].createElement(StyledCountry, {
      disabled: disabled,
      onClick: function onClick() {
        return onChoose(country);
      },
      key: country_code
    }, /*#__PURE__*/_react["default"].createElement(StyledFlag, {
      closed: closed,
      className: "lt-flag lt-flag-".concat((country_code === null || country_code === void 0 ? void 0 : country_code.toLowerCase()) || 'us')
    }), /*#__PURE__*/_react["default"].createElement(StyledName, {
      closed: closed
    }, /*#__PURE__*/_react["default"].createElement("p", null, name_ru), /*#__PURE__*/_react["default"].createElement(StyledVisa, {
      noVisa: noVisa,
      closed: closed
    }, visaAvailability)));
  };
  return /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledColumn, null, priorityCountries.map(drawColumn)), /*#__PURE__*/_react["default"].createElement(StyledColumn, null, allCountries.slice(0, 14).map(drawColumn)), /*#__PURE__*/_react["default"].createElement(StyledColumn, null, allCountries.slice(14, 28).map(drawColumn)), /*#__PURE__*/_react["default"].createElement(StyledColumn, null, allCountries.slice(28, 42).map(drawColumn)), /*#__PURE__*/_react["default"].createElement(StyledColumn, null, allCountries.slice(42, 56).map(drawColumn)));
};
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "CountryTable__StyledWrapper",
  componentId: "sc-1fdjd46-0"
})(["width:fit-content;display:flex;flex-direction:row;box-shadow:0px 1px 2px rgba(210,208,197,0.9),0px 10px 15px rgba(216,214,204,0.9);border-radius:5px;overflow:hidden;", ""], (0, _Flags.flagSprite)());
var StyledCountry = _styledComponents["default"].div.withConfig({
  displayName: "CountryTable__StyledCountry",
  componentId: "sc-1fdjd46-1"
})(["width:100%;height:40px;width:151px;background-color:#fff;box-sizing:border-box;font-size:14px;line-height:16px;padding-top:9px;cursor:pointer;&:hover{background-color:#e6f2ff;}", ""], function (_ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return disabled && "\n      opacity: 0.6;\n      pointer-events: none;\n      cursor: initial;\n    ";
});
var StyledColumn = _styledComponents["default"].div.withConfig({
  displayName: "CountryTable__StyledColumn",
  componentId: "sc-1fdjd46-2"
})(["display:flex;flex-direction:column;flex-wrap:wrap;height:560px;max-height:560px;background-color:#fff;"]);
var StyledFlag = _styledComponents["default"].div.withConfig({
  displayName: "CountryTable__StyledFlag",
  componentId: "sc-1fdjd46-3"
})(["margin:0 8px;float:left;", ""], function (_ref2) {
  var closed = _ref2.closed;
  return closed && "\n    filter: grayscale(1);\n    opacity: 0.6;\n  ";
});
var StyledName = _styledComponents["default"].div.withConfig({
  displayName: "CountryTable__StyledName",
  componentId: "sc-1fdjd46-4"
})(["float:left;font-size:14px;line-height:16px;color:", ";"], function (_ref3) {
  var theme = _ref3.theme,
    closed = _ref3.closed;
  return closed ? theme.colors.greyLight : theme.colors.blackBase;
});
var StyledVisa = _styledComponents["default"].p.withConfig({
  displayName: "CountryTable__StyledVisa",
  componentId: "sc-1fdjd46-5"
})(["font-size:9px;line-height:12px;color:", ";"], function (_ref4) {
  var theme = _ref4.theme,
    noVisa = _ref4.noVisa,
    closed = _ref4.closed;
  return noVisa || closed ? theme.colors.greyLight : theme.colors.blue;
});